/* ============================================================
   Logo alt text fix
   The header logo can have an empty or generic alt; give it a
   meaningful one based on the shop name from the page title.
   ============================================================ */
(function () {
  'use strict';
 
  var LOGO_SELECTORS = [
    '.header__heading-logo img',
    '.site-header__logo img',
    '.header-wrapper img[src*="logo"]',
    '.header img[src*="logo"]',
    'a[href="/"] img',
    'header img',
  ];
 
  function fixLogoAlt() {
    var rawTitle  = document.title || '';
    var shopName  = rawTitle.split(/[–—\-|]/g).pop().trim() || 'Store';
    var altText   = shopName + ' logo — return to homepage';
 
    LOGO_SELECTORS.some(function (sel) {
      var imgs = document.querySelectorAll(sel);
      if (!imgs.length) return false;
 
      imgs.forEach(function (img) {
        var current = (img.getAttribute('alt') || '').trim().toLowerCase();
        var isBad = !current || current === 'logo' || current === 'image'
                    || current === 'header logo' || current === 'site logo';
        if (isBad) {
          img.setAttribute('alt', altText);
        }
      });
      return true;
    });
  }
 
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', fixLogoAlt)
    : fixLogoAlt();
 
})();

(function () {
  'use strict';
 
  function labelPaginationLinks() {
    var container = document.querySelector('.pagination');
    if (!container) return;
 
    /* ── Numbered page links ──────────────────────────────── */
    container.querySelectorAll('.page a').forEach(function (a) {
      var num = a.textContent.trim();
      if (num) a.setAttribute('aria-label', 'Go to page ' + num);
    });
 
    /* ── Current page (not a link, but give it context too) ── */
    container.querySelectorAll('.page.current').forEach(function (el) {
      var num = el.textContent.trim();
      if (num) {
        el.setAttribute('aria-label', 'Page ' + num + ', current page');
        el.setAttribute('aria-current', 'page');
      }
    });
 
    /* ── Previous ─────────────────────────────────────────── */
    var prev = container.querySelector('.prev a, .previous a');
    if (prev) prev.setAttribute('aria-label', 'Go to previous page');
 
    /* ── Next ─────────────────────────────────────────────── */
    var next = container.querySelector('.next a');
    if (next) next.setAttribute('aria-label', 'Go to next page');
 
    /* ── Ellipsis ─────────────────────────────────────────── */
    container.querySelectorAll('.deco').forEach(function (el) {
      el.setAttribute('aria-hidden', 'true');
    });
  }
 
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', labelPaginationLinks)
    : labelPaginationLinks();
 
})();

/* ============================================================
   Slack Embed — Broken aria-labelledby Fix
   ============================================================ */
(function () {
  'use strict';

  var MESSAGE_SELECTOR = '[data-qa="virtual-list-item"][aria-labelledby]';

  function fixBrokenAriaRefs(root) {
    (root || document).querySelectorAll(MESSAGE_SELECTOR).forEach(function (el) {
      var labelledBy = el.getAttribute('aria-labelledby') || '';
      var ids = labelledBy.trim().split(/\s+/).filter(Boolean);
      var allMissing = ids.length > 0 && ids.every(function (id) {
        return !document.getElementById(id);
      });

      if (!allMissing) return;

      var text = el.textContent.replace(/\s+/g, ' ').trim().slice(0, 200);
      if (text) el.setAttribute('aria-label', text);
      el.removeAttribute('aria-labelledby');
    });
  }

  function init() {
    fixBrokenAriaRefs();

    var listRoot = document.querySelector('[data-qa="message_pane"]') || document.body;

    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches(MESSAGE_SELECTOR)) {
            fixBrokenAriaRefs(node.parentElement);
          } else if (node.querySelector) {
            fixBrokenAriaRefs(node);
          }
        });
      });
    }).observe(listRoot, { childList: true, subtree: true });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

})();

/* ============================================================
   Size Selector — works with id="product-size-btn" as-is
   ============================================================ */
(function () {
  'use strict';

  function init() {
    var trigger = document.getElementById('product-size-btn');
    var popup   = document.getElementById('sizes-select-popup');
    var label   = document.querySelector('label[for="product-size"]');
    if (!trigger || !popup) return;

    /* Fix label association — point it at the actual trigger id */
    if (label) label.setAttribute('for', 'product-size-btn');

    /* Give trigger an id that also satisfies the original for="product-size"
       by adding a second reference via aria-labelledby on the trigger */
    trigger.setAttribute('id', 'product-size-btn'); /* keep existing id */
    trigger.setAttribute('aria-labelledby', label ? 'size-label-ref' : '');
    if (label) label.id = 'size-label-ref';

    /* Combobox roles */
    trigger.setAttribute('role', 'combobox');
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-controls', 'sizes-select-popup');
    trigger.setAttribute('tabindex', '0');

    popup.setAttribute('role', 'listbox');
    popup.setAttribute('tabindex', '-1');

    /* ── Label every li ──────────────────────────────────────── */
    function labelItems() {
      popup.querySelectorAll('li').forEach(function (li) {
        var size     = (li.getAttribute('data-value') || '').toUpperCase();
        var qty      = parseInt(li.getAttribute('data-inventory_quantity') || '0', 10);
        var avail    = li.classList.contains('available');
        var selected = li.classList.contains('selected');
        var label    = size;
        if (!avail)                   label += ', sold out';
        else if (qty > 0 && qty <= 8) label += ', ' + qty + ' left';
        if (selected)                 label += ', currently selected';
        li.setAttribute('role', 'option');
        li.setAttribute('aria-label', label);
        li.setAttribute('aria-selected', selected ? 'true' : 'false');
        li.setAttribute('tabindex', selected ? '0' : '-1');
        if (!avail) li.setAttribute('aria-disabled', 'true');
      });

      /* Sync trigger label with selected size */
      var sel = popup.querySelector('li.selected');
      if (sel) {
        var size = (sel.getAttribute('data-value') || '').toUpperCase();
        trigger.setAttribute('aria-label', 'Size: ' + size);
      }
    }

    labelItems();

    /* ── Track open/close via hide-dom class ─────────────────── */
    function isOpen() {
      return !popup.classList.contains('hide-dom');
    }

    new MutationObserver(function () {
      trigger.setAttribute('aria-expanded', isOpen() ? 'true' : 'false');
      if (isOpen()) labelItems();
    }).observe(popup, { attributes: true, attributeFilter: ['class'] });

    /* Also watch li class changes for selected state updates */
    new MutationObserver(labelItems)
      .observe(popup, { subtree: true, attributeFilter: ['class'] });

    trigger.setAttribute('aria-expanded', 'false');

    /* ── Keyboard on trigger ─────────────────────────────────── */
    trigger.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'ArrowDown') return;
      e.preventDefault();
      if (!isOpen()) trigger.click();
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          var target = popup.querySelector('li.selected') ||
                       popup.querySelector('li.available');
          if (target) target.focus();
        });
      });
    });

    /* ── Keyboard inside popup ───────────────────────────────── */
    popup.addEventListener('keydown', function (e) {
      var items = Array.from(popup.querySelectorAll('li.available'));
      var idx   = items.indexOf(document.activeElement);

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        (items[idx + 1] || items[0]).focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        (items[idx - 1] || items[items.length - 1]).focus();
      } else if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (popup.contains(document.activeElement)) {
          document.activeElement.click();
        }
      } else if (e.key === 'Escape') {
        trigger.click();
        trigger.focus();
      }
    });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();

/* ============================================================
   Size Guide trigger — keyboard accessibility fix
   ============================================================ */
(function () {
  'use strict';

  function init() {
    document.querySelectorAll('.btn-call-size-guide').forEach(function (btn) {
      if (btn.dataset.a11yFixed) return;

      /* Make it reachable and announced correctly */
      btn.setAttribute('role', 'button');
      btn.setAttribute('tabindex', '0');
      btn.setAttribute('aria-haspopup', 'dialog');

      /* Identify the popup it controls */
      var targetId = btn.getAttribute('data-target');
      if (targetId) btn.setAttribute('aria-controls', targetId);

      /* Activate on Enter and Space, matching native button behaviour */
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          btn.click();
        }
      });

      btn.dataset.a11yFixed = 'true';
    });

    /* ── Size guide popup (form-size-guide) ──────────────────── */
    fixPopup();
  }

  function fixPopup() {
    var popup = document.querySelector('.form-popup.form-size-guide, #form-size-guide, [id="form-size-guide"]');
    if (!popup || popup.dataset.a11yFixed) return;

    /* Make it a proper dialog */
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-modal', 'true');
    popup.setAttribute('aria-label', 'Size Guide');

    /* Close button */
    var closeBtn = popup.querySelector('.close-form-size-guide-btn');
    if (closeBtn) {
      closeBtn.setAttribute('role', 'button');
      closeBtn.setAttribute('tabindex', '0');
      closeBtn.setAttribute('aria-label', 'Close size guide');
      closeBtn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          closeBtn.click();
        }
      });
    }

    /* Move focus into popup when it opens, return focus on close */
    var lastFocus = null;

    new MutationObserver(function () {
      var isOpen = popup.classList.contains('open');
      if (isOpen) {
        lastFocus = document.activeElement;
        var first = popup.querySelector(
          'button, [role="button"], a[href], input, [tabindex="0"]'
        );
        if (first) setTimeout(function () { first.focus(); }, 50);
      } else if (lastFocus) {
        lastFocus.focus();
        lastFocus = null;
      }
    }).observe(popup, { attributes: true, attributeFilter: ['class'] });

    popup.dataset.a11yFixed = 'true';
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();

/* ============================================================
   Search result tabs — proper keyboard behaviour
   ARIA tablist pattern: Arrow keys switch tabs, Enter/Space
   activates, Tab moves out of the tablist entirely.
   ============================================================ */
(function () {
  'use strict';

  function init() {
    var tablist = document.querySelector('.snize-main-panel-controls[role="tablist"]');
    if (!tablist || tablist.dataset.a11yFixed) return;

    var tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;

    /* ── Fix <ul> — role="presentation" is correct but the <li>
       wrappers also need it so AT skips the list structure    */
    tablist.querySelectorAll('li').forEach(function (li) {
      li.setAttribute('role', 'presentation');
    });

    /* ── Ensure each tab has tabindex set correctly on load ─── */
    function setTabindexes(activeTab) {
      tabs.forEach(function (tab) {
        tab.setAttribute('tabindex', tab === activeTab ? '0' : '-1');
      });
    }

    var current = tabs.find(function (t) {
      return t.getAttribute('aria-selected') === 'true';
    }) || tabs[0];

    setTabindexes(current);

    /* ── Each tab panel needs id + the tab needs aria-controls ─
       Snize doesn't render explicit panel ids so we create them */
    tabs.forEach(function (tab, i) {
      var panelId = 'snize-tab-panel-' + i;
      tab.setAttribute('id', 'snize-tab-' + i);

      /* Try to find the matching panel by class convention */
      var cls = tab.className.replace('snize-main-panel-controls-', '').split(' ')[0];
      var panel = document.querySelector('.snize-' + cls + '-panel, .snize-panel-' + cls);
      if (panel) {
        panel.setAttribute('id', panelId);
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', 'snize-tab-' + i);
        panel.setAttribute('tabindex', '0');
        tab.setAttribute('aria-controls', panelId);
      }
    });

    /* ── Announce count inside span accessibly ──────────────── */
    tabs.forEach(function (tab) {
      var countSpan = tab.querySelector('span[class*="total"]');
      if (countSpan && !countSpan.getAttribute('aria-label')) {
        var count = countSpan.textContent.trim();
        countSpan.setAttribute('aria-label', count + ' results');
      }
    });

    /* ── Keyboard handler ────────────────────────────────────── */
    tablist.addEventListener('keydown', function (e) {
      var idx = tabs.indexOf(document.activeElement);
      if (idx === -1) return;

      var next;

      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        next = tabs[idx + 1] || tabs[0];
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        next = tabs[idx - 1] || tabs[tabs.length - 1];
      } else if (e.key === 'Home') {
        e.preventDefault();
        next = tabs[0];
      } else if (e.key === 'End') {
        e.preventDefault();
        next = tabs[tabs.length - 1];
      } else if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        tabs[idx].click();
        return;
      }

      if (next) {
        next.focus();
        next.click(); /* activate immediately on arrow key (ARIA pattern) */
      }
    });

    /* ── Keep tabindexes in sync when app changes active tab ─── */
    new MutationObserver(function () {
      var active = tabs.find(function (t) {
        return t.getAttribute('aria-selected') === 'true';
      });
      if (active) setTabindexes(active);
    }).observe(tablist, { subtree: true, attributeFilter: ['aria-selected'] });

    tablist.dataset.a11yFixed = 'true';
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();

/* ============================================================
   Snize Price Filter — Accessibility Fix
   Fixes all 6 issues without touching the app's own JS
   ============================================================ */
(function () {
  'use strict';

  var fixed = false;

  function fixPriceFilter() {
    if (fixed) return;

    var btn = document.querySelector('.snize-filter-title[role="button"]');
    var container = document.querySelector('.slider-container');

    /* Wait until both elements exist before running */
    if (!btn || !container) return;

    fixed = true;

    /* ── Toggle button ──────────────────────────────────────── */
    var label = Array.from(btn.childNodes)
      .filter(function (n) {
        return n.nodeType === 3 ||
          (n.nodeType === 1 && n.getAttribute('aria-hidden') !== 'true');
      })
      .map(function (n) { return n.textContent.trim(); })
      .filter(Boolean).join(' ').replace(/\s+/g, ' ').trim();

    btn.removeAttribute('aria-labelledby');
    btn.setAttribute('aria-label', label || 'Price filter');

    var group = btn.closest('[role="group"]');
    if (group && group.hasAttribute('aria-expanded')) {
      btn.setAttribute('aria-expanded', group.getAttribute('aria-expanded'));
      group.removeAttribute('aria-expanded');

      new MutationObserver(function () {
        var list = group.querySelector('ul, .snize-filter-options');
        btn.setAttribute('aria-expanded',
          list && window.getComputedStyle(list).display === 'none' ? 'false' : 'true'
        );
      }).observe(group, {
        attributes: true, childList: true, subtree: true,
        attributeFilter: ['class', 'style']
      });
    }

    if (!btn.getAttribute('tabindex')) btn.setAttribute('tabindex', '0');
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); btn.click(); }
    });

    /* Caret */
    var caret = btn.querySelector('b.caret, .caret');
    if (caret) caret.setAttribute('aria-hidden', 'true');

    /* ── Range slider ───────────────────────────────────────── */
    var lowPtr  = container.querySelector('.pointer.low');
    var highPtr = container.querySelector('.pointer.high');
    var backBar = container.querySelector('.back-bar');
    if (!lowPtr || !highPtr || !backBar) return;

    var scaleValues = Array.from(container.querySelectorAll('.scale span ins'))
      .map(function (i) { return parseFloat(i.textContent.replace(/[^0-9.]/g, '')); })
      .filter(function (n) { return !isNaN(n); });

    var gMin = scaleValues.length ? Math.min.apply(null, scaleValues) : 0;
    var gMax = scaleValues.length ? Math.max.apply(null, scaleValues) : 100;
    var minInput = document.querySelector('.snize-range-min-price');
    var maxInput = document.querySelector('.snize-range-max-price');
    var step = Math.round((gMax - gMin) / 20) || 1;

    function getMin() { return minInput ? parseFloat(minInput.value) || gMin : gMin; }
    function getMax() { return maxInput ? parseFloat(maxInput.value) || gMax : gMax; }
    function fmt(v)   { return '$' + Math.round(v); }

    lowPtr.setAttribute('role', 'slider');
    lowPtr.setAttribute('tabindex', '0');
    lowPtr.setAttribute('aria-label', 'Minimum price');
    lowPtr.setAttribute('aria-valuemin', gMin);
    lowPtr.setAttribute('aria-valuemax', gMax);
    lowPtr.setAttribute('aria-valuenow', getMin());
    lowPtr.setAttribute('aria-valuetext', fmt(getMin()));

    highPtr.setAttribute('role', 'slider');
    highPtr.setAttribute('tabindex', '0');
    highPtr.setAttribute('aria-label', 'Maximum price');
    highPtr.setAttribute('aria-valuemin', gMin);
    highPtr.setAttribute('aria-valuemax', gMax);
    highPtr.setAttribute('aria-valuenow', getMax());
    highPtr.setAttribute('aria-valuetext', fmt(getMax()));

    lowPtr.addEventListener('keydown', function (e) {
      var v = getMin();
      if      (e.key === 'ArrowRight' || e.key === 'ArrowUp')   { e.preventDefault(); v = Math.min(v + step, getMax() - step); }
      else if (e.key === 'ArrowLeft'  || e.key === 'ArrowDown')  { e.preventDefault(); v = Math.max(v - step, gMin); }
      else if (e.key === 'Home') { e.preventDefault(); v = gMin; }
      else if (e.key === 'End')  { e.preventDefault(); v = getMax() - step; }
      else return;
      if (minInput) { minInput.value = v; minInput.dispatchEvent(new Event('change', { bubbles: true })); minInput.dispatchEvent(new Event('input', { bubbles: true })); }
      lowPtr.setAttribute('aria-valuenow', v);
      lowPtr.setAttribute('aria-valuetext', fmt(v));
    });

    highPtr.addEventListener('keydown', function (e) {
      var v = getMax();
      if      (e.key === 'ArrowRight' || e.key === 'ArrowUp')   { e.preventDefault(); v = Math.min(v + step, gMax); }
      else if (e.key === 'ArrowLeft'  || e.key === 'ArrowDown')  { e.preventDefault(); v = Math.max(v - step, getMin() + step); }
      else if (e.key === 'Home') { e.preventDefault(); v = getMin() + step; }
      else if (e.key === 'End')  { e.preventDefault(); v = gMax; }
      else return;
      if (maxInput) { maxInput.value = v; maxInput.dispatchEvent(new Event('change', { bubbles: true })); maxInput.dispatchEvent(new Event('input', { bubbles: true })); }
      highPtr.setAttribute('aria-valuenow', v);
      highPtr.setAttribute('aria-valuetext', fmt(v));
    });

    if (minInput) minInput.addEventListener('change', function () { lowPtr.setAttribute('aria-valuenow', getMin()); lowPtr.setAttribute('aria-valuetext', fmt(getMin())); });
    if (maxInput) maxInput.addEventListener('change', function () { highPtr.setAttribute('aria-valuenow', getMax()); highPtr.setAttribute('aria-valuetext', fmt(getMax())); });

    /* Scale ins elements */
    container.querySelectorAll('.scale ins').forEach(function (ins) {
      ins.setAttribute('role', 'presentation');
      ins.setAttribute('aria-hidden', 'true');
    });

    /* Wrap pointers in group */
    var grp = document.createElement('div');
    grp.setAttribute('role', 'group');
    grp.setAttribute('aria-label', 'Price range');
    backBar.parentNode.insertBefore(grp, backBar);
    grp.appendChild(backBar);
  }

  /* Poll until the filter widget appears — no body observer */
  function init() {
    var tries = 0;
    var t = setInterval(function () {
      fixPriceFilter();
      if (fixed || ++tries > 50) clearInterval(t);
    }, 200);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

})();

/* ============================================================
   Snize Search Pagination — Contextual link labels fix
   ============================================================ */
(function () {
  'use strict';

  function fixPagination() {
    document.querySelectorAll('.snize-pagination').forEach(function (nav) {

      /* ── Numbered page links ──────────────────────────────── */
      nav.querySelectorAll('a[rev]').forEach(function (a) {
        var page = a.getAttribute('rev');
        if (!page) return;

        /* Skip prev/next — they have their own labels */
        if (a.classList.contains('snize-pagination-next') ||
            a.classList.contains('snize-pagination-prev')) return;

        var isCurrent = a.getAttribute('aria-current') === 'page';
        a.setAttribute(
          'aria-label',
          isCurrent
            ? 'Page ' + page + ', current page'
            : 'Go to page ' + page
        );
      });

      /* ── Previous link/span ───────────────────────────────── */
      var prev = nav.querySelector('.snize-pagination-prev');
      if (prev) {
        var prevDisabled = prev.classList.contains('disabled');
        if (prev.tagName === 'A') {
          prev.setAttribute('aria-label',
            prevDisabled ? 'Previous page, you are on the first page' : 'Go to previous page'
          );
        }
        /* The disabled <span> is already aria-hidden="true" — correct */
      }

      /* ── Next link ────────────────────────────────────────── */
      var next = nav.querySelector('.snize-pagination-next');
      if (next && next.tagName === 'A') {
        var nextPage = next.getAttribute('rev');
        next.setAttribute('aria-label',
          nextPage
            ? 'Go to next page, page ' + nextPage
            : 'Go to next page'
        );
      }

      /* ── Ellipsis ─────────────────────────────────────────── */
      nav.querySelectorAll('li span:not([class])').forEach(function (el) {
        if (el.textContent.trim() === '...') {
          el.setAttribute('aria-hidden', 'true');
          /* Insert visually-hidden text for AT */
          if (!el.nextElementSibling ||
              !el.nextElementSibling.classList.contains('snize-sr-ellipsis')) {
            var sr = document.createElement('span');
            sr.className = 'snize-sr-ellipsis';
            sr.textContent = 'more pages';
            sr.setAttribute('style',
              'position:absolute;width:1px;height:1px;padding:0;' +
              'margin:-1px;overflow:hidden;clip:rect(0,0,0,0);' +
              'white-space:nowrap;border:0;');
            el.parentNode.insertBefore(sr, el.nextSibling);
          }
        }
      });

      /* ── <ul> and <li> list semantics ────────────────────── */
      var ul = nav.querySelector('ul');
      if (ul) ul.setAttribute('role', 'list');
      nav.querySelectorAll('li').forEach(function (li) {
        li.setAttribute('role', 'listitem');
      });
    });
  }

  function init() {
    fixPagination();

    /* Re-run when Snize replaces pagination on page change */
    new MutationObserver(fixPagination)
      .observe(document.body, { childList: true, subtree: true });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();

